export default [
  {
    key: 'increasement',
    sortable: false,
    sortField: '',
    label: '#',
    thClass: 'w-50px',
  },
  {
    key: 'channelName',
    label: 'field.channel',
    stickyColumn: true,
    variant: 'light',
  },
  {
    key: 'id',
    label: 'field.no',
  },
  {
    key: 'result',
    label: 'field.result',
  },
  {
    key: 'videoUrl',
    label: 'field.video',
  },
  {
    key: 'betTime',
    label: 'field.betTime',
  },
  {
    key: 'fullTime',
    label: 'field.fullTime',
  },
  {
    key: 'status',
    label: 'field.status',
  },
  {
    key: 'actions',
    label: 'general.action',
  },
]
